import { render } from "./studioCourseXb.vue?vue&type=template&id=1f336914&scoped=true"
import script from "./studioCourseXb.vue?vue&type=script&lang=js"
export * from "./studioCourseXb.vue?vue&type=script&lang=js"

import "./studioCourseXb.vue?vue&type=style&index=0&id=1f336914&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f336914"]])

export default __exports__